import React, { useState, useEffect } from "react";

/**
 * Displays company logo or avatar with company name initials as fallback.
 * Only uses logo when it's a valid URL (http/https). Falls back to initials on image error.
 */
const CompanyAvatar = ({ company, className = "", size = "md" }) => {
  const name = company?.name || "";
  const initials = name
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2) || "?";
  const logoRaw = company?.logoUrl || company?.logo;
  const isValidUrl = logoRaw && (logoRaw.startsWith("http://") || logoRaw.startsWith("https://"));
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [company?._id, logoRaw]);

  const showImg = isValidUrl && !imgError;

  const sizeClasses = {
    xs: "w-6 h-6 text-xs",
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  };
  const s = sizeClasses[size] || sizeClasses.md;
  const imgSizes = { xs: "!w-6 !h-6", sm: "!w-8 !h-8", md: "!w-10 !h-10", lg: "!w-12 !h-12" };
  const imgSize = imgSizes[size] || imgSizes.md;

  if (showImg) {
    return (
      <img
        src={logoRaw}
        alt={name}
        onError={() => setImgError(true)}
        className={`${imgSize} rounded-lg object-cover shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${s} rounded-lg flex items-center justify-center shrink-0 font-bold bg-primary/10 text-primary ${className}`}
      title={name}
    >
      {initials}
    </div>
  );
};

export default CompanyAvatar;
